module.exports = __webpack_public_path__ + "img/suchen-active.ff78ebf9.svg";